<script setup lang="ts">
import QuizterLayout from './layout/QuizterLayout.vue';
import useLocale from '../composables/use-locale';

const emit = defineEmits<{
  'go-create': [];
  'go-shared': [];
  'go-my': [];
  'go-back': [];
}>();

const { t } = useLocale();
</script>

<template>
  <QuizterLayout :showHeader="false">
    <div class="d-flex flex-column align-center justify-center ga-12 w-100">
      <h1 class="chalkduster-font text-white text-center text-h1">Quizter!</h1>

      <v-row class="mt-6 ga-6" justify="center">
        <v-col>
          <v-card
            variant="outlined"
            color="white"
            class="game-card h-100"
            :ripple="true"
            tabindex="0"
            role="button"
            data-testid="quizter-home-my-quizters-card"
            @click="emit('go-my')"
            @keydown.enter="emit('go-my')"
            @keydown.space.prevent="emit('go-my')"
          >
            <v-card-text class="text-center pa-6 d-flex flex-column align-center justify-center h-100">
              <v-avatar size="80" class="mb-4">
                <v-icon icon="fa:fawsb fa-heart" size="40" color="white"></v-icon>
              </v-avatar>
              <h2 class="chalkboard-font text-h5 mb-2 text-white">{{ t('quizter.home.my_quizters') }}</h2>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col>
          <v-card
            variant="outlined"
            color="white"
            class="game-card h-100"
            :ripple="true"
            tabindex="0"
            role="button"
            data-testid="quizter-home-shared-with-me-card"
            @click="emit('go-shared')"
            @keydown.enter="emit('go-shared')"
            @keydown.space.prevent="emit('go-shared')"
          >
            <v-card-text class="text-center pa-6 d-flex flex-column align-center justify-center h-100">
              <v-avatar size="80" class="mb-4">
                <v-icon icon="fa:fas fa-arrow-down-to-square" size="40" color="white"></v-icon>
              </v-avatar>
              <h2 class="chalkboard-font text-h5 mb-2 text-white">{{ t('quizter.home.shared_with_me') }}</h2>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col>
          <v-card
            variant="outlined"
            color="white"
            class="game-card h-100"
            :ripple="true"
            tabindex="0"
            role="button"
            data-testid="quizter-home-create-card"
            @click="emit('go-create')"
            @keydown.enter="emit('go-create')"
            @keydown.space.prevent="emit('go-create')"
          >
            <v-card-text class="text-center pa-6 d-flex flex-column align-center justify-center h-100">
              <v-avatar size="80" class="mb-4">
                <v-icon icon="fa:fawsb fa-plus" size="40" color="white"></v-icon>
              </v-avatar>
              <h2 class="chalkboard-font text-h5 mb-2 text-white">{{ t('quizter.home.create_quizter') }}</h2>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </QuizterLayout>
</template>

<style scoped lang="scss">
.game-card {
  min-width: 325px;
  min-height: 258px;
  border-width: 3px;
}
</style>
